import { useRef, useState } from "react";
import { Camera, Check } from "lucide-react";

function compress(file, cb) {
  const img = new Image();
  img.onload = () => {
    const canvas = document.createElement("canvas");
    const scale = Math.min(800 / img.width, 1);
    canvas.width = img.width * scale;
    canvas.height = img.height * scale;
    canvas.getContext("2d").drawImage(img, 0, 0, canvas.width, canvas.height);
    cb(canvas.toDataURL("image/jpeg", 0.6));
  };
  img.src = URL.createObjectURL(file);
}

export default function PhotoInput({ label, value, onChange, testId, allowGallery = false }) {
  const ref = useRef();
  const [preview, setPreview] = useState(value || null);
  return (
    <div>
      <input ref={ref} type="file" accept="image/*" {...(allowGallery ? {} : { capture: "environment" })} className="hidden"
        data-testid={`${testId}-input`}
        onChange={(e) => {
          const f = e.target.files?.[0];
          if (f) compress(f, (b64) => { setPreview(b64); onChange(b64); });
        }} />
      <button type="button" data-testid={testId} onClick={() => ref.current.click()}
        className={`flex w-full items-center gap-3 rounded-xl border-2 border-dashed p-3 text-sm font-medium transition-colors ${preview ? "border-emerald-400 bg-emerald-50 text-emerald-700" : "border-slate-300 bg-white text-slate-600"}`}>
        {preview ? <Check size={18} /> : <Camera size={18} />}
        {preview ? `${label} captured` : allowGallery ? `Capture or upload ${label}` : `Capture ${label}`}
        {preview && <img src={preview} alt="" className="ml-auto h-10 w-10 rounded-lg object-cover" />}
      </button>
    </div>
  );
}
